import { truckModeEnum } from "../truck";


export const isTruckContextEnabled = (mode: number | undefined, context: 'departure' | 'arrival' | 'transfer' | 'onSite' | 'secondTimeOnSite'): boolean => {
    if (mode == null || isNaN(mode)) return false;
    switch (context) {
        case 'departure':
            return [truckModeEnum.APPRO, truckModeEnum.POSE, truckModeEnum.DOUBLEFRET].includes(mode);
        case 'arrival':
            return [truckModeEnum.EVAC, truckModeEnum.ENLEVEMENT, truckModeEnum.ROTATION, truckModeEnum.BACKANDFORTH, truckModeEnum.DOUBLEFRET].includes(mode);
        case 'transfer':
            return mode === truckModeEnum.TRANSFER;
        case 'onSite':
            return mode === truckModeEnum.ONSITE;
        case 'secondTimeOnSite':
            return [truckModeEnum.BACKANDFORTH].includes(mode);
        default:
            return false;
    }
};